import React, { useState, useEffect } from 'react';
import { subscribeToCompassState } from './ble';
import DeviceConnection from './DeviceConnection';
import ProtobufObjectTable from './ProtobufObjectTable';
import CompassOrientation from './CompassOrientation';
import './StateCharacteristic.css';
import CompassCalibration from './CompassCalibration';
import protobuf from 'protobufjs';
import CompassStateBar from './CompassStateBar';

const StateCharacteristic = () => {
  const [compassState, setCompassState] = useState({});
  const [compassStateError, setCompassStateError] = useState(null);
  const [protobufRoot, setProtobufRoot] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [connectionLost, setConnectionLost] = useState(false);

  useEffect(() => {
    const loadProtobuf = async () => {
      const root = await protobuf.load('/compassData.proto');
      setProtobufRoot(root);
    };

    loadProtobuf();
  }, []);

  const handleConnect = async () => {
    setIsConnected(true);
    setConnectionLost(false);
    subscribeToCompassState((newState) => {
      setCompassState(newState);
      setCompassStateError(null);
    });
  };

  const handleDisconnect = () => {
    setIsConnected(false);
    setConnectionLost(true);
  };

  if (!protobufRoot) {
    return <div>Loading Protobuf...</div>;
  }

  const containerClass = `
    state-characteristic-container 
    ${connectionLost ? 'disconnected' : ''} 
    ${!isConnected && !connectionLost ? 'offline' : ''}
  `;

  return (
    <div className={containerClass.trim()}>
      <DeviceConnection onConnect={handleConnect} onDisconnect={handleDisconnect} />

      {true /*isConnected || connectionLost*/ ? (
        <>
          <div className="main-layout">
            <div className="left-column">
              <CompassStateBar compassState={compassState} />
              <CompassOrientation compassState={compassState} />
              <CompassCalibration isConnected={isConnected} compassState={compassState} />
            </div>

            <div className="right-column">
              <div className="table-container">
                <h3>Compass State</h3>
                {compassStateError ? (
                  <div className="error-message">{compassStateError}</div>
                ) : (
                  <ProtobufObjectTable object={compassState} typeName="compass.CompassState" protobufRoot={protobufRoot} />
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>Device not connected</div>
      )}
    </div>
  );
};

export default StateCharacteristic;
